module.exports = function() {
    var $slideShows = $('.image-slideshow');
    var $thumbnails = $slideShows.find('.image-slideshow-thumbnails');

    $slideShows.each(function () {
        var $slideShow = $(this);
            
        var swiperContainer = $slideShow.find('.swiper')[0];
        var previousButton = $slideShow.find('.image-slideshow-previous-button')[0];
        var nextButton = $slideShow.find('.image-slideshow-next-button')[0];
        var pagination = $slideShow.find('.image-slideshow-pagination')[0];

        var swiper = new Swiper(swiperContainer, {
            direction: 'horizontal',
            loop: false,
            speed: 500,
            navigation: {
                nextEl: nextButton,
                prevEl: previousButton,
            },
            pagination: {
                el: pagination,
                clickable: true
            },
            on: {
                slideChange(swiper) {
                    $thumbnails.find('.image-slideshow-thumbnail-active').removeClass('image-slideshow-thumbnail-active');
                    $thumbnails.find('.image-slideshow-thumbnail:eq(' + swiper.activeIndex + ')').addClass('image-slideshow-thumbnail-active');
                }
            }            
        });

        $thumbnails.find('.image-slideshow-thumbnail').click(function () {
            var numberOfSlides = Math.abs($(this).index() - swiper.activeIndex);

            if (numberOfSlides > 0) {
                swiper.slideTo($(this).index(), numberOfSlides * 500 - (numberOfSlides - 1) * 250, true);
            }
        });
    });
};